import { render, staticRenderFns } from "./GuideManagement.vue?vue&type=template&id=71470519&scoped=true"
import script from "./GuideManagement.vue?vue&type=script&lang=js"
export * from "./GuideManagement.vue?vue&type=script&lang=js"
import style0 from "./GuideManagement.vue?vue&type=style&index=0&id=71470519&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71470519",
  null
  
)

export default component.exports